var map = {
	"./add.svg": 67,
	"./captain.svg": 68,
	"./check.svg": 69,
	"./close.svg": 44,
	"./dropdown.svg": 70,
	"./file-upload.svg": 71,
	"./focus.svg": 72,
	"./fullscreen.svg": 73,
	"./lang/en.svg": 74,
	"./lang/th.svg": 75,
	"./lang/vi.svg": 76,
	"./loading.svg": 77,
	"./minute.svg": 78,
	"./play.svg": 79,
	"./search.svg": 80,
	"./slide.svg": 81,
	"./social/facebook-messenger.svg": 82,
	"./social/facebook-share.svg": 83,
	"./social/facebook.svg": 84,
	"./social/instagram.svg": 85,
	"./social/twitter.svg": 86,
	"./social/youtube.svg": 87,
	"./to-top.svg": 88,
	"./tournament/format.svg": 89,
	"./tournament/game-mode.svg": 90,
	"./tournament/location.svg": 91,
	"./tournament/prize-pool.svg": 92,
	"./tournament/starting-date.svg": 93,
	"./tournament/trophy.svg": 94
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 66;